import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  type: "button",
  class: "btn btn-success me-3 d-none",
  ref: "view_template_mail",
  "data-bs-toggle": "modal",
  "data-bs-target": "#view_template_mail"
}
const _hoisted_2 = {
  class: "modal fade",
  id: "view_template_mail",
  ref: "createAppModalRef",
  tabindex: "-1",
  "aria-hidden": "true"
}
const _hoisted_3 = { class: "modal-dialog modal-dialog-centered modal-xl" }
const _hoisted_4 = { class: "modal-content" }
const _hoisted_5 = { class: "modal-body py-lg-4 px-lg-5" }
const _hoisted_6 = ["innerHTML"]
const _hoisted_7 = { class: "text-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("button", _hoisted_1, null, 512),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", null, [
              _createElementVNode("h3", null, _toDisplayString(_ctx.title), 1)
            ]),
            _createElementVNode("div", {
              class: "p-5 custom-table-editor",
              innerHTML: _ctx.html
            }, null, 8, _hoisted_6),
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("button", {
                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.closeModal && _ctx.closeModal(...args))),
                class: "btn btn-primary m-auto"
              }, "Đóng")
            ])
          ])
        ])
      ])
    ], 512)
  ], 64))
}